module.exports = __webpack_public_path__ + "img/citations.d130cc9.png";